import { render, staticRenderFns } from "./ZnapShotCaseStudy.vue?vue&type=template&id=45aeec7d&scoped=true"
import script from "./ZnapShotCaseStudy.vue?vue&type=script&lang=js"
export * from "./ZnapShotCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./ZnapShotCaseStudy.vue?vue&type=style&index=0&id=45aeec7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aeec7d",
  null
  
)

export default component.exports